/**
 * CoureHub.Addressbook.Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddressBookRequstDto } from '../model/addressBookRequstDto';
import { AddressBookResponseDto } from '../model/addressBookResponseDto';
import { AllAddressBookResponseDto } from '../model/allAddressBookResponseDto';
import { UpdateAddressBookRequstDto } from '../model/updateAddressBookRequstDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AddressBookService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookDeletAddressBookIdDelete(id: string, observe?: 'body', reportProgress?: boolean): Observable<AddressBookResponseDto>;
    public apiAddressBookDeletAddressBookIdDelete(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookResponseDto>>;
    public apiAddressBookDeletAddressBookIdDelete(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookResponseDto>>;
    public apiAddressBookDeletAddressBookIdDelete(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiAddressBookDeletAddressBookIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AddressBookResponseDto>('delete',`${this.basePath}/api/AddressBook/DeletAddressBook/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookGetAddressBookByIdIDGet(ID: string, observe?: 'body', reportProgress?: boolean): Observable<AddressBookResponseDto>;
    public apiAddressBookGetAddressBookByIdIDGet(ID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookResponseDto>>;
    public apiAddressBookGetAddressBookByIdIDGet(ID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookResponseDto>>;
    public apiAddressBookGetAddressBookByIdIDGet(ID: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ID === null || ID === undefined) {
            throw new Error('Required parameter ID was null or undefined when calling apiAddressBookGetAddressBookByIdIDGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AddressBookResponseDto>('get',`${this.basePath}/api/AddressBook/GetAddressBookById/${encodeURIComponent(String(ID))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param SPID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookGetAddressBookBySPIdSPIDGet(SPID: string, observe?: 'body', reportProgress?: boolean): Observable<AllAddressBookResponseDto>;
    public apiAddressBookGetAddressBookBySPIdSPIDGet(SPID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllAddressBookResponseDto>>;
    public apiAddressBookGetAddressBookBySPIdSPIDGet(SPID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllAddressBookResponseDto>>;
    public apiAddressBookGetAddressBookBySPIdSPIDGet(SPID: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (SPID === null || SPID === undefined) {
            throw new Error('Required parameter SPID was null or undefined when calling apiAddressBookGetAddressBookBySPIdSPIDGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllAddressBookResponseDto>('get',`${this.basePath}/api/AddressBook/GetAddressBookBySPId/${encodeURIComponent(String(SPID))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookGetAllAddressBookGet(observe?: 'body', reportProgress?: boolean): Observable<AllAddressBookResponseDto>;
    public apiAddressBookGetAllAddressBookGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllAddressBookResponseDto>>;
    public apiAddressBookGetAllAddressBookGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllAddressBookResponseDto>>;
    public apiAddressBookGetAllAddressBookGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllAddressBookResponseDto>('get',`${this.basePath}/api/AddressBook/GetAllAddressBook`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookInsertAddressBookPost(body?: AddressBookRequstDto, observe?: 'body', reportProgress?: boolean): Observable<AddressBookResponseDto>;
    public apiAddressBookInsertAddressBookPost(body?: AddressBookRequstDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookResponseDto>>;
    public apiAddressBookInsertAddressBookPost(body?: AddressBookRequstDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookResponseDto>>;
    public apiAddressBookInsertAddressBookPost(body?: AddressBookRequstDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AddressBookResponseDto>('post',`${this.basePath}/api/AddressBook/InsertAddressBook`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAddressBookUpdateAddressBookPut(body?: UpdateAddressBookRequstDto, observe?: 'body', reportProgress?: boolean): Observable<AddressBookResponseDto>;
    public apiAddressBookUpdateAddressBookPut(body?: UpdateAddressBookRequstDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddressBookResponseDto>>;
    public apiAddressBookUpdateAddressBookPut(body?: UpdateAddressBookRequstDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddressBookResponseDto>>;
    public apiAddressBookUpdateAddressBookPut(body?: UpdateAddressBookRequstDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AddressBookResponseDto>('put',`${this.basePath}/api/AddressBook/UpdateAddressBook`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
